var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "actions-ui",
      class: { "abort-btn-hidden": _vm.hideAbortBtn }
    },
    [
      !_vm.hideAbortBtn
        ? _c(
            "button",
            {
              staticClass: "btn-black grey",
              class: { disabled: _vm.loading },
              attrs: { disabled: _vm.loading },
              on: { click: _vm.handleAbort }
            },
            [_vm._v("\n    " + _vm._s(_vm.abortBtnText) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-black",
          class: { disabled: _vm.continueDisabled || _vm.loading },
          attrs: { disabled: _vm.continueDisabled },
          on: { click: _vm.handleContinue }
        },
        [_vm._v("\n    " + _vm._s(_vm.continueBtnText) + "\n  ")]
      ),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Questions? "),
      _c("a", { attrs: { href: "mailto:support+trials@brilliant.org" } }, [
        _vm._v("Contact support")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }